import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  // eslint-disable-next-line consistent-return
  async downloadWord(params) {
    try {
      const response = await axios.get('uni/tnhReports/reportStudentManagementRegister', { params, responseType: 'blob' })
      if (response.status === 200) {
        return response.data
      }
      return null
    } catch (e) {
      handleCatch(e)
    }
  },
  async getStudentChangeRequest(params) {
    try {
      const response = await axios.get('uni/studentChangeRequest', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async approveStudentChangeRequest(studentId) {
    try {
      const response = await axios.post(`uni/studentChangeRequest/approve/${studentId}`)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async rejectStudentChangeRequest(studentId, params) {
    try {
      const response = await axios.post(`uni/studentChangeRequest/reject/${studentId}`, params)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
